import { 
    FaHashtag,  
    FaUser, 
    FaUserTag, 
    AppEnum,
    Header,
    PublicationEnums,
    AppEnumHelper,
    sortByLabel,
    OptionHelper
} from "@/Shared";

import { PublicationViewModel } from ".";

export class PublicationHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    getAdSourceType(adSourceTypes: AppEnum[]) {
        return {
            key: 'adSourceType',
            icon: <FaUserTag />,
            label: "Type d'annonce",
            type: 'string',
            isSortable: true,
            filter: {
                label: "Type",
                options: OptionHelper.sortByLabel(adSourceTypes),
                case: 'sensitive'
            }
        }
    }

    getAdSourceCategory(adSourceCategories: AppEnum[]) {
        return {
            key: 'adSourceCategory',
            icon: <FaUserTag />,
            label: "Catégorie d'annonce",
            type: 'string',
            isSortable: true,
            filter: {
                label: "Catégorie",
                options: OptionHelper.sortByLabel(adSourceCategories),
                case: 'sensitive'
            }
        }
    }

    get firstPostedAt() {
        return {
            key: 'firstPostedAt',
            icon: <FaUser />,
            label: 'Publié le',
            type: 'string',
            isSortable: true
        }
    }

    get endPostedAt() {
        return {
            key: 'endPostedAt',
            icon: <FaUser />,
            label: 'Fin publication',
            type: 'string',
            isSortable: true
        }
    }

    get note() {
        return {
            key: 'note',
            icon: <FaUserTag />,
            label: 'Note',
            type: 'string',
            isSortable: true
        }
    }

    static build(
        viewEnums : PublicationEnums,
    ): Record<keyof PublicationViewModel, Header<PublicationViewModel>> {

        const header = new PublicationHeader();

        const {AdSourceTypeEnum, AdSourceCategoryEnum} = viewEnums;

        return {
            id: header.id,
            adSourceType: header.getAdSourceType(AdSourceTypeEnum),
            adSourceCategory: header.getAdSourceCategory(AdSourceCategoryEnum),
            firstPostedAt: header.firstPostedAt,
            endPostedAt: header.endPostedAt,
            note: header.note,
            propertyId: { 
                key: 'propertyId', 
                label: 'ID bien', 
                type: 'number', 
                isSortable: true 
            }
        } as Record<keyof PublicationViewModel, Header<PublicationViewModel>>;
    }
}
